import {getCookie, setCookie, eraseCookie} from './cookie';

export default function orders() {
	var products_table = document.querySelector( '.products__table' );
	if (products_table) {
		var products_list = products_table.querySelectorAll( '.products__item' );
		if (products_list.length > 0) {
			products_list.forEach( ( item ) => {
				productActions( item );
			} );
		}
	}
}

const productActions = ( item ) => {
	var nav_sub = item.querySelector(
		'.products__quantity-navs .products__quantity-nav--sub' );
	var nav_add = item.querySelector(
		'.products__quantity-navs .products__quantity-nav--add' );

	var selected_quanity = item.querySelector( '.products__selected-quantity' );

	var selected_package = item.querySelector( '.products__selected-package' );

	var add_button = item.querySelector( '.products__add-button' );
	var remove_button = item.querySelector( '.products__remove-from-cart' );

	nav_add.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		selected_quanity.value = parseInt( selected_quanity.value ) + 1;
		updateValue( item );
	} );

	nav_sub.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		var new_quantity = parseInt( selected_quanity.value ) - 1;
		if (new_quantity > 0) {
			selected_quanity.value = new_quantity;
		} else {
			selected_quanity.value = 1;
		}
		updateValue( item );
	} );

	selected_quanity.addEventListener( 'change', ( e ) => {
		updateValue( item );
	} );

	if (selected_package) {
		var observer = new MutationObserver( function( mutationsList, observer ) {
			var selected_package_id = item.querySelector(
				'.products__selected-package' ).dataset.value;
			var selected_package_quantity = item.querySelector(
				'.products__select-package .custom-select__option[data-value="' +
				selected_package_id + '"]' ).dataset.package_quantity;
			selected_package.dataset.package_quantity = selected_package_quantity;
			updateValue( item );
		} );

		observer.observe( selected_package,
			{characterData: false, childList: true, attributes: false} );
	}

	if (add_button) {
		add_button.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			addToCart( item );
			setTimeout( () => {
				window.location.href = add_button.dataset.redirect_to;
			}, 800 );
		} );
	}

	if (remove_button) {
		remove_button.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			removeFromCart( item );
		} );
	}

	document.addEventListener( 'wpcf7submit', function( event ) {
		if ("mail_sent" == event.detail.apiResponse.status && ('341' == event.detail.contactFormId || '369' ==
			event.detail.contactFormId)) {
			eraseCookie( 'cart' );
			var products_list = document.querySelectorAll( '.products__table .products__item' );
			var products_sum = document.querySelector( '.products__table .products__sum' );
			products_sum.classList.add('d-none');
			products_sum.classList.remove('d-flex');
			document.querySelector( '.products__table .products__empty-order' ).classList.remove('d-none');
			products_list.forEach( ( item ) => {
				item.parentElement.removeChild( item );
			} );
			// do something productive
		}
	}, false );

};

const updateValue = ( item ) => {
	var product_value = item.querySelector( '.products__value' );
	var product_value_brutto = item.querySelector( '.products__value-brutto' );
	var product_price = item.querySelector( '.products__price' ).dataset.price;
	var selected_package = item.querySelector(
		'.products__selected-package' );
	if(!product_price || !selected_package) {
		return false;
	}
	var selected_package_quantity = selected_package.dataset.package_quantity;
	var selected_package_id = selected_package.dataset.value;


	var selected_quantity = item.querySelector(
		'.products__selected-quantity' ).value;
	var final_value = parseFloat( product_price ) *
		parseInt( selected_quantity ) * parseFloat( selected_package_quantity );
	final_value = (Math.round( (final_value + Number.EPSILON) * 100 ) /
		100).toFixed( 2 );

	product_value.innerHTML = number_format( final_value, 2, '.', '&nbsp;' ) + '&nbsp;zł';
	if (product_value_brutto) {

		var product_price_brutto = item.querySelector(
			'.products__price-brutto' ).dataset.price;

		var final_value_brutto = parseFloat( product_price_brutto ) *
			parseInt( selected_quantity ) * parseFloat( selected_package_quantity );
		final_value_brutto = (Math.round(
			(final_value_brutto + Number.EPSILON) * 100 ) /
			100).toFixed( 2 );

		product_value_brutto.innerHTML = number_format( final_value_brutto, 2, '.',
			'&nbsp;' ) + '&nbsp;zł';
		product_value_brutto.dataset.price = final_value_brutto;
	}

	item.dataset.package_id = selected_package_id;
	item.dataset.final_value = final_value;
	item.dataset.quantity = selected_quantity;

	if (item.classList.contains( 'update-cart' )) {
		updateCart( item );
	}
	refreshCartSum();
};

const addToCart = ( item ) => {
	var cookie = getCookie( 'cart' );
	var cart = [];
	if (cookie) {
		cart = JSON.parse( cookie );

		let item_exist = cart.find( ( cart_item, cart_index ) => {
			if (cart_item.product_id === parseInt( item.dataset.product_id ) &&
				cart_item.package_id === parseInt( item.dataset.package_id )) {
				cart[cart_index] = {
					product_id: parseInt( item.dataset.product_id ),
					package_id: parseInt( item.dataset.package_id ),
					final_value: parseFloat( cart_item.final_value ) +
						parseFloat( item.dataset.final_value ),
					quantity: parseInt( cart_item.quantity ) +
						parseInt( item.dataset.quantity ),
				};
				return true;
			}
		} );
		if (!item_exist) {
			cart.push( {
				product_id: parseInt( item.dataset.product_id ),
				package_id: parseInt( item.dataset.package_id ),
				final_value: parseFloat( item.dataset.final_value ),
				quantity: parseInt( item.dataset.quantity ),
			} );
		}
	} else {
		cart.push( {
				product_id: parseInt( item.dataset.product_id ),
				package_id: parseInt( item.dataset.package_id ),
				final_value: parseFloat( item.dataset.final_value ),
				quantity: parseInt( item.dataset.quantity ),
			},
		);
	}
	console.log( cart );

	return setCookie( 'cart', JSON.stringify( cart ), 1 );
};

const updateCart = ( item ) => {
	var cookie = getCookie( 'cart' );
	var cart = [];
	if (cookie) {
		cart = JSON.parse( cookie );

		let item_exist = cart.find( ( cart_item, cart_index ) => {
			console.log( cart_item.product_id, parseInt( item.dataset.product_id ),
				cart_item.package_id, parseInt( item.dataset.package_id ) );
			if (cart_item.product_id === parseInt( item.dataset.product_id ) &&
				cart_item.package_id === parseInt( item.dataset.package_id )) {

				cart[cart_index] = {
					product_id: parseInt( item.dataset.product_id ),
					package_id: parseInt( item.dataset.package_id ),
					final_value: parseFloat( item.dataset.final_value ),
					quantity: parseInt( item.dataset.quantity ),
				};
				return true;
			}
		} );

		setCookie( 'cart', JSON.stringify( cart ), 1 );
	}

};

const getCartSum = () => {
	var products = document.querySelectorAll(
		'.products__table .products__item .products__value-brutto' );
	var sum = 0;
	products.forEach( ( item ) => {
		sum = sum + parseFloat( item.dataset.price );
	} );
	return sum;
};

const removeFromCart = ( item ) => {
	var cookie = getCookie( 'cart' );
	var cart = [];
	if (cookie) {
		cart = JSON.parse( cookie );

		let item_exist = cart.find( ( cart_item, cart_index ) => {
			console.log( cart_item.product_id, parseInt( item.dataset.product_id ),
				cart_item.package_id, parseInt( item.dataset.package_id ) );
			if (cart_item.product_id === parseInt( item.dataset.product_id ) &&
				cart_item.package_id === parseInt( item.dataset.package_id )) {
				cart.splice( cart_index, 1 );
				//item.classList.add( 'd-none' );
				item.parentElement.removeChild( item );
				if (cart.length === 0) {
					document.querySelector( '.products__empty-order' ).
						classList.
						remove( 'd-none' );
				}
				return true;
			}
		} );

		setCookie( 'cart', JSON.stringify( cart ), 1 );
	}
	refreshCartSum();
};

const refreshCartSum = () => {
	var products_sum = document.querySelector( '.products__sum-value' );
	if (products_sum) {
		console.log( getCartSum() );
		products_sum.innerHTML = number_format( getCartSum(), 2, '.',
			'&nbsp;' ) + '&nbsp;zł';
	}
}

const number_format = ( number, decimals, dec_point, thousands_point ) => {

	if (number == null || !isFinite( number )) {
		throw new TypeError( 'number is not valid' );
	}

	if (!decimals) {
		var len = number.toString().split( '.' ).length;
		decimals = len > 1 ? len : 0;
	}

	if (!dec_point) {
		dec_point = '.';
	}

	if (!thousands_point) {
		thousands_point = ',';
	}

	number = parseFloat( number ).toFixed( decimals );

	number = number.replace( '.', dec_point );

	var splitNum = number.split( dec_point );
	splitNum[0] = splitNum[0].replace( /\B(?=(\d{3})+(?!\d))/g, thousands_point );
	number = splitNum.join( dec_point );

	return number;
};
